import { onMonacoInitialized } from "environment-interface/monacoEditor/browser/services/editor/vscode/monaco";
import type { DependencyList } from "react";
import { useEffect } from "react";

export const useVSCodeExtensionInitializedEffect = (
  cb: () => void | (() => void),
  deps?: DependencyList,
) =>
  useEffect(() => {
    let isRunning = true;
    let disposer: void | (() => void) | undefined;

    onMonacoInitialized(() => {
      if (isRunning) {
        disposer = cb();
      }
    });

    return () => {
      isRunning = false;
      disposer?.();
    };
  }, deps);
